import React, { memo } from "react";
import "./MobileBottomAppBar.css";
import { Box } from "@mui/material";

interface MobileBottomAppBarProps {
    children: React.ReactElement;
}

const MobileBottomAppBar = memo((props: MobileBottomAppBarProps) => {
    return <Box className="bottom-nav-bar-container">{props.children}</Box>;
});

export default MobileBottomAppBar;
